import api, { unwrap, unwrapList } from './api';
import type { Invoice, SubscriptionSetting, SubscriptionSettingUpdate } from '../types';

export const subscriptionsService = {
  invoices: (status?: string) => api.get('admin/subscriptions/invoices', { params: status ? { status } : {} }).then((r) => unwrapList<Invoice>(r).data),
  markPaid: (id: string) => api.post(`admin/subscriptions/invoices/${id}/mark-paid`).then(unwrap<Invoice>),
  getSettings: () => api.get('admin/subscriptions/settings').then(unwrap<SubscriptionSetting>),
  updateSettings: (body: SubscriptionSettingUpdate) => api.put('admin/subscriptions/settings', body).then(unwrap<SubscriptionSetting>),
};
